import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Message from "@/components/Message/index";
import { Loading, ButtonLoading } from "@/components/Loading";
import Header, { NavList } from "@/components/Base/header";
import Footer from "@/components/Base/footer";
import { newPath } from '@/utils/index'
import { ambassadorApply } from '@/api/index'
import Countrys from './countrys'
import { ApplyRoot, Form } from './css'

const ExpertiseList = [ 'Art', 'Community', 'Copywriting', 'Design', 'Game', 'Crazy about Dmail', 'Leadership', 'Marketing', 'Technical', 'Translation']
const FromList = [ 'Referred by a friend', 'Twitter', 'Telegram', 'Other' ]

const defaultFields = {
  refemail: '',
  firstname: '',
  lastname: '',
  email: '',
  contry: '',
  city: '',
  state: '',
  socialsize: '',
  twitter: '',
  linkedin: '',
  expertise: '',
  about: '',
  hearfrom: '',
  otherFrom: '',
}
const notRequiredFields = ['refemail', 'linkedin', 'otherFrom']
const max = 200;

const Index = ({ store }) => {
  const history = useHistory();
  const { isMobile, windowSize } = store.common;
  const isSmall = windowSize < 800
  const mobileClass = isMobile ? `sub-mobile ${isSmall ? 'sm-mobile' : ''}` : ''

  const [loading, setLoading] = useState(false)
  const [num, setNum] = useState(0)
  const [errorfields, setErrorFields] = useState({})
  const errorFieldsRef = useRef(errorfields)
  const _setErrorFields = (key, value) => {
    const newFields = {
      ...errorFieldsRef.current,
      ...{ [key]: value }
    }
    errorFieldsRef.current = newFields
    setErrorFields(newFields)
  }

  const [fields, setFields] = useState(defaultFields)
  const fieldsRef = useRef(fields)
  const _setFields = (key, value) => {
    const newFields = {
      ...fieldsRef.current,
      ...{ [key]: value }
    }
    if (key === 'about') {
      if (value.length > max) {
        return
      }
      setNum(value.length)
    }
    if (value) {
      if (key === 'hearfrom' && value === FromList[FromList.length - 1]) {
        //
      } else if (key === 'otherFrom') {
        _setErrorFields('hearfrom', false)
      } else {
        _setErrorFields(key, false)
      }
    }
    fieldsRef.current = newFields
    setFields(newFields)
  }

  const onInput = (key) => (ev) => {
    _setFields(key, ev.target.value)
  }

  const onSelectFrom = (value, key) => () => {
    _setFields(key, value)
    if (key === 'hearfrom' && value === FromList[FromList.length - 1]) {
      setTimeout(() => {
        document.querySelector('#otherInput').focus()
      }, 200);
    }
  }

  const onSubmit = async () => {
    const errors = {}
    Object.keys(fields).forEach(key => {
      if (fields.hearfrom === FromList[FromList.length - 1] && !fields.otherFrom.trim().length) {
        errors.hearfrom = true
        return
      }
      if (!notRequiredFields.includes(key) && !fields[key]) {
        errors[key] = true
      }
    })
    errorFieldsRef.current = errors
    setErrorFields(errors)
    if (Object.values(errors).filter(error => !!error).length) {
      setTimeout(() => {
        const dom = document.querySelector('.error')
        dom && dom.scrollIntoView({
          block: 'center',
          behavior: "smooth",
        })
      }, 200);
      return
    }
    const params = { ...fields }
    if (params.hearfrom === FromList[FromList.length - 1]) {
      params.hearfrom = params.otherFrom
    }
    delete params.otherFrom
    setLoading(true);
    const { msg, code } = await ambassadorApply(params)
    setLoading(false);
    if( code == 1){
      history.push(`${newPath}/apply_success`)
    } else {
      Message.error(msg)
    }
  }

  return (
    <ApplyRoot className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName={NavList[2].name} />
      <div className="center">
        <div className="breadcrumbs">
          <a onClick={() => history.push(`${newPath}/`)}>Home</a>/<a onClick={() => history.push(`${newPath}/ambassador`)}>Ambassador Program</a>/<span>Apply</span>
        </div>
        <Form className={mobileClass}>
          {/* <Back mobile={isSmall} text="Apply Dmail Ambassador Program" backPath="/ambassador" /> */}
          <div className="chunk" style={{ marginTop: 0 }}>
            <h1>Apply Dmail Ambassador Program</h1>
            <dl>
              <dt className="referral-title">Referral Email (Optional)-The email address that invited you here</dt>
              <dd>
                <input type="text" className='referral' value={fields.refemail} onInput={onInput('refemail')} placeholder="Not required, please enter the name of the referrer" />
                <div className="note">If you have a strong referring person, you have a high chance to be selected. This field is optional.</div>
              </dd>
            </dl>
          </div>
          <div className="flex">
            <div className="chunk">
              <dl>
                <dt>Contact information <span>*</span></dt>
                <dd>
                  <div className="item">
                    <div className="label">Your Name</div>
                    <div className="value">
                      <input className={errorfields.firstname ? 'error' : ''} type="text" value={fields.firstname} onInput={onInput('firstname')} placeholder="First" />
                      <input className={errorfields.lastname ? 'error' : ''} type="text" value={fields.lastname} onInput={onInput('lastname')} placeholder="Last" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="label">Your E-mail</div>
                    <div className="value">
                      <input className={errorfields.email ? 'error' : ''} type="text" value={fields.email} onInput={onInput('email')} placeholder="E-mail address" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="label">Your Location</div>
                    <div className="value">
                      <div className={errorfields.contry ? 'error select' : 'select'}>
                        <FormControl sx={{ m: 1, width: '100%' }}>
                          <InputLabel id="demo-simple-select-helper-label">Country</InputLabel>
                          <Select
                            value={fields.contry}
                            onChange={onInput('contry')}
                            displayEmpty
                            label="Country"
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                            {Countrys.map((item,i) => (
                              <MenuItem key={item[0]} value={item[0]}>
                                {item[1]}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="value" style={{ marginTop: '20px' }}>
                      <input className={errorfields.city ? 'error' : ''} type="text" value={fields.city} onInput={onInput('city')} placeholder="City" />
                      <input className={errorfields.state ? 'error' : ''} type="text" value={fields.state} onInput={onInput('state')} placeholder="State / Region / Province" />
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
            <div className="chunk">
              <dl>
                <dt>Your social media <span>*</span></dt>
                <dd>
                  <div className="item">
                    <div className="label">What is the size of the community you can reach directly <span>*</span></div>
                    <div className="value">
                      <input className={errorfields.socialsize ? 'error' : ''} type="text" value={fields.socialsize} onInput={onInput('socialsize')} placeholder="Please enter the community size" />
                    </div>
                  </div>
                  <div className="item twitter">
                    <div className="label">Your Twitter URL <span>*</span></div>
                    <div className="value">
                      <input className={errorfields.twitter ? 'error' : ''} type="text" value={fields.twitter} onInput={onInput('twitter')} placeholder="Your Twitter URL" />
                    </div>
                  </div>
                  <div className="item">
                    <div className="label">Your Linkedin URL</div>
                    <div className="value">
                      <input type="text" value={fields.linkedin} onInput={onInput('linkedin')} placeholder="Not required, Your Linkedin URL" />
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
          <div className="chunk">
            <dl>
              <dt>Your area of expertise <span>*</span></dt>
              <dd>
                <div className="radios normal">
                  {ExpertiseList.map((value) => (
                    <p className={`radio ${value === fields.expertise ? 'on' : ''}`} onClick={onSelectFrom(value, 'expertise')} key={value}>
                      <i></i>
                      <span>{ value }</span>
                    </p>
                  ))}
                </div>
                {errorfields.expertise ? <p className='error' style={{ position: 'absolute', marginTop: '-7px', }}>Select a choice</p> : null}
              </dd>
            </dl>
          </div>
          <div className="chunk">
            <dl className={errorfields.about ? 'error' : ''}>
              <dt>Please briefly tell us about yourself <span>*</span></dt>
              <dd>
                <div className="textarea">
                  <textarea value={fields.about} onInput={onInput('about')} cols="30" rows="6" placeholder='You can share your relavant experience and resources'></textarea>
                  <div className="count">{ num } / { max }</div>
                </div>
              </dd>
            </dl>
          </div>
          <div className="chunk">
            <dl>
              <dt>How did you hear about Dmail <span>*</span></dt>
              <dd>
                <div className="radios">
                  {FromList.map((value) => (
                    <p className={`radio ${value === fields.hearfrom ? 'on' : ''} ${value === 'Other' ? 'other' : ''}`} onClick={onSelectFrom(value, 'hearfrom')} key={value}>
                      <i></i>
                      <span>{ value }</span>
                      {value === 'Other' && fields.hearfrom === 'Other' ?
                        <input value={fields.otherFrom} onInput={onInput('otherFrom')} id="otherInput" type="text" placeholder='Fill you in own' /> :
                        null
                      }
                    </p>
                  ))}
                </div>
                {errorfields.hearfrom ? <p className='error' style={{ position: 'absolute', marginTop: '-7px', }}>Select a choice</p> : null}
              </dd>
            </dl>
          </div>
          <div className="actions">
            <a className={`filled-red ${loading ? 'loading' : ''}`} onClick={onSubmit}>{loading ? <ButtonLoading size={20} /> : null}<span className='text'>Submit</span></a>
            <a className="back" onClick={() => history.push(`${newPath}/ambassador`)}>Back</a>
          </div>
        </Form>
      </div>
      <div className="bottom">
        <div className="center">
          <Footer />
        </div>
      </div>
    </ApplyRoot>
  )
}

export default withRouter(inject("store")(observer(Index)))